import { render, staticRenderFns } from "./DynamicIndex.vue?vue&type=template&id=3380494a"
import script from "./DynamicIndex.vue?vue&type=script&lang=js"
export * from "./DynamicIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports